/**
 * Phase 40 — how a lane is named outside the pool step. The verdict report,
 * the replay, the history, the timeline, the experiment line and the
 * list-override pin all read a row that may carry `laneLabel`
 * ("23Telecom · AUSSIEWIN") next to its route name: the lane wins, the route
 * name is the fallback. The pickers list the pool's lanes by letter (a stored
 * pin finds its lane through the shared `laneForDraft`).
 * For Media Devoted | Created By Ciro Autiero
 */
import { type DropGenGatewayLane, laneLabel, laneLetter } from '@trafficpulse/shared';

export interface LaneNamedRow {
  routeId: number;
  routeName?: string | null;
  laneLabel?: string | null;
}

/** "23Telecom · AUSSIEWIN" when the row knows its lane, else the route's name, else "route 1750". */
export const laneOrRouteName = (row: LaneNamedRow): string => row.laneLabel ?? row.routeName ?? `route ${row.routeId}`;

/** A stable key for a row that may be one lane of a gateway. */
export const laneRowKey = (row: { routeId: number; laneId?: string | null }): string => `${row.routeId}:${row.laneId ?? '*'}`;

export interface LaneOption {
  /** The lane's id. */
  value: string;
  /** "B · 23Telecom · AUSSIEWIN". */
  label: string;
  routeId: number;
}

/** The pool's lanes as picker options, lettered as the pool shows them. */
export const laneOptions = (pool: readonly DropGenGatewayLane[], nameOf: (routeId: number) => string | null): LaneOption[] =>
  pool.map((lane, i) => ({ value: lane.id, label: `${laneLetter(i)} · ${laneLabel(lane, nameOf(lane.routeId))}`, routeId: lane.routeId }));
